module.exports = __webpack_public_path__ + "img/Vcredit.dcb57053.png";